/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Ai_Scope_HintInputs */

const cs_blog_ai_scope_hint = /** @type {(inputs: Blog_Ai_Scope_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Akce se vztahují na záložku ${i?.locale} vybranou nahoře.`)
};

const en_blog_ai_scope_hint = /** @type {(inputs: Blog_Ai_Scope_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions apply to the ${i?.locale} tab selected above.`)
};

/**
* | output |
* | --- |
* | "Actions apply to the {locale} tab selected above." |
*
* @param {Blog_Ai_Scope_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_scope_hint = /** @type {((inputs: Blog_Ai_Scope_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Scope_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_scope_hint(inputs)
	return cs_blog_ai_scope_hint(inputs)
});